import { useGlobalStore } from '~/stores/global';

export default defineNuxtPlugin(async (nuxtApp) => {
    const globalStore = useGlobalStore();

    // Предзагрузка данных настроек при инициализации приложения
    if (process.server) {
        await globalStore.fetchSettings();
    }

    return {
        provide: {
            globalStore
        }
    };
});
